export default {"src":"/_next/static/media/11.51ec6aba.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};